import { resolveLocalized } from "./i18n";
const SCREEN_LABELS = {
    home: "Start",
    apps: "Apps",
    info: "Information",
    radio: "Radio",
    hotel: "Hotel",
};
const COPY_PARTS = [
    { key: "kicker", label: "Kicker" },
    { key: "headline", label: "Headline" },
    { key: "subtitle", label: "Subtitle" },
];
function crumb(value, fallback) {
    const text = resolveLocalized(value, "", "").trim();
    if (text.length === 0)
        return fallback;
    return text.length > 32 ? `${text.slice(0, 31)}…` : text;
}
function replaceAt(list, index, next) {
    const copy = list.slice();
    copy[index] = next;
    return copy;
}
function infoSectionFields(sections, idPrefix, labelPrefix, put) {
    const out = [];
    sections.forEach((section, i) => {
        var _a;
        const head = crumb(section.section, `Section ${i + 1}`);
        out.push({
            id: `${idPrefix}[${i}].section`,
            label: `${labelPrefix} · ${head} · Heading`,
            prose: false,
            read: () => { var _a; return (_a = sections[i]) === null || _a === void 0 ? void 0 : _a.section; },
            write: (content, next) => put(content, replaceAt(sections, i, { ...sections[i], section: next })),
        });
        ((_a = section.items) !== null && _a !== void 0 ? _a : []).forEach((item, j) => {
            const itemHead = crumb(item.label, `Row ${j + 1}`);
            out.push({
                id: `${idPrefix}[${i}].items[${j}].label`,
                label: `${labelPrefix} · ${head} · ${itemHead} (label)`,
                prose: false,
                read: () => { var _a, _b, _c; return (_c = (_b = (_a = sections[i]) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b[j]) === null || _c === void 0 ? void 0 : _c.label; },
                write: (content, next) => put(content, replaceAt(sections, i, {
                    ...sections[i],
                    items: replaceAt(sections[i].items, j, {
                        ...sections[i].items[j],
                        label: next,
                    }),
                })),
            });
            out.push({
                id: `${idPrefix}[${i}].items[${j}].value`,
                label: `${labelPrefix} · ${head} · ${itemHead}`,
                prose: true,
                read: () => { var _a, _b, _c; return (_c = (_b = (_a = sections[i]) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b[j]) === null || _c === void 0 ? void 0 : _c.value; },
                write: (content, next) => put(content, replaceAt(sections, i, {
                    ...sections[i],
                    items: replaceAt(sections[i].items, j, {
                        ...sections[i].items[j],
                        value: next,
                    }),
                })),
            });
        });
    });
    return out;
}
function copyFields(copy) {
    const out = [];
    Object.keys(SCREEN_LABELS).forEach((screen) => {
        const screenCopy = copy[screen];
        if (!screenCopy)
            return;
        COPY_PARTS.forEach(({ key, label }) => {
            if (screenCopy[key] === undefined)
                return;
            out.push({
                id: `copy.${screen}.${key}`,
                label: `${SCREEN_LABELS[screen]} · ${label}`,
                prose: key === "subtitle",
                read: (content) => { var _a, _b; return (_b = (_a = content.copy) === null || _a === void 0 ? void 0 : _a[screen]) === null || _b === void 0 ? void 0 : _b[key]; },
                write: (content, next) => {
                    var _a;
                    return ({
                        ...content,
                        copy: {
                            ...content.copy,
                            [screen]: { ...(_a = content.copy) === null || _a === void 0 ? void 0 : _a[screen], [key]: next },
                        },
                    });
                },
            });
        });
    });
    return out;
}
function actionListFields(lists) {
    const out = [];
    lists.forEach((list, i) => {
        var _a;
        const head = crumb(list.title, list.id || `List ${i + 1}`);
        if (list.title !== undefined) {
            out.push({
                id: `actionLists[${i}].title`,
                label: `Actions · ${head} · Heading`,
                prose: false,
                read: (content) => { var _a, _b; return (_b = (_a = content.actionLists) === null || _a === void 0 ? void 0 : _a[i]) === null || _b === void 0 ? void 0 : _b.title; },
                write: (content, next) => ({
                    ...content,
                    actionLists: replaceAt(lists, i, { ...lists[i], title: next }),
                }),
            });
        }
        ((_a = list.actions) !== null && _a !== void 0 ? _a : []).forEach((action, j) => {
            const actionHead = crumb(action.label, action.id || `Action ${j + 1}`);
            out.push({
                id: `actionLists[${i}].actions[${j}].label`,
                label: `Actions · ${head} · ${actionHead}`,
                prose: false,
                read: (content) => { var _a, _b, _c, _d; return (_d = (_c = (_b = (_a = content.actionLists) === null || _a === void 0 ? void 0 : _a[i]) === null || _b === void 0 ? void 0 : _b.actions) === null || _c === void 0 ? void 0 : _c[j]) === null || _d === void 0 ? void 0 : _d.label; },
                write: (content, next) => ({
                    ...content,
                    actionLists: replaceAt(lists, i, {
                        ...lists[i],
                        actions: replaceAt(lists[i].actions, j, {
                            ...lists[i].actions[j],
                            label: next,
                        }),
                    }),
                }),
            });
            if (action.detail === undefined)
                return;
            out.push({
                id: `actionLists[${i}].actions[${j}].detail`,
                label: `Actions · ${head} · ${actionHead} (detail)`,
                prose: true,
                read: (content) => { var _a, _b, _c, _d; return (_d = (_c = (_b = (_a = content.actionLists) === null || _a === void 0 ? void 0 : _a[i]) === null || _b === void 0 ? void 0 : _b.actions) === null || _c === void 0 ? void 0 : _c[j]) === null || _d === void 0 ? void 0 : _d.detail; },
                write: (content, next) => ({
                    ...content,
                    actionLists: replaceAt(lists, i, {
                        ...lists[i],
                        actions: replaceAt(lists[i].actions, j, {
                            ...lists[i].actions[j],
                            detail: next,
                        }),
                    }),
                }),
            });
        });
    });
    return out;
}
function customFields(items) {
    const out = [];
    items.forEach((item, i) => {
        const head = crumb(item.label, item.id || `Item ${i + 1}`);
        out.push({
            id: `custom.items[${i}].label`,
            label: `Custom · ${head}`,
            prose: false,
            read: (content) => { var _a, _b, _c; return (_c = (_b = (_a = content.custom) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b[i]) === null || _c === void 0 ? void 0 : _c.label; },
            write: (content, next) => ({
                ...content,
                custom: { items: replaceAt(items, i, { ...items[i], label: next }) },
            }),
        });
        if (!item.text)
            return;
        out.push({
            id: `custom.items[${i}].text.body`,
            label: `Custom · ${head} · Body`,
            prose: true,
            read: (content) => { var _a, _b, _c, _d; return (_d = (_c = (_b = (_a = content.custom) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b[i]) === null || _c === void 0 ? void 0 : _c.text) === null || _d === void 0 ? void 0 : _d.body; },
            write: (content, next) => ({
                ...content,
                custom: {
                    items: replaceAt(items, i, {
                        ...items[i],
                        text: { ...items[i].text, body: next },
                    }),
                },
            }),
        });
    });
    return out;
}
function slotFields(slots) {
    const out = [];
    for (const slotId of Object.keys(slots).sort()) {
        const stored = slots[slotId];
        const wasList = Array.isArray(stored);
        const fills = wasList ? stored : [stored];
        const putFill = (content, index, fill) => {
            const nextFills = replaceAt(fills, index, fill);
            return {
                ...content,
                slots: {
                    ...content.slots,
                    [slotId]: wasList ? nextFills : nextFills[0],
                },
            };
        };
        fills.forEach((fill, i) => {
            const where = wasList ? `${slotId} #${i + 1}` : slotId;
            if (fill.type === "announcement") {
                if (fill.title !== undefined) {
                    out.push({
                        id: `slots.${slotId}[${i}].title`,
                        label: `Slot · ${where} · Title`,
                        prose: false,
                        read: () => fills[i] && fills[i].title,
                        write: (content, next) => putFill(content, i, { ...fill, title: next }),
                    });
                }
                out.push({
                    id: `slots.${slotId}[${i}].body`,
                    label: `Slot · ${where} · Announcement`,
                    prose: true,
                    read: () => fills[i].body,
                    write: (content, next) => putFill(content, i, { ...fill, body: next }),
                });
            }
            else if (fill.type === "qr" && fill.label !== undefined) {
                out.push({
                    id: `slots.${slotId}[${i}].label`,
                    label: `Slot · ${where} · QR label`,
                    prose: false,
                    read: () => fills[i].label,
                    write: (content, next) => putFill(content, i, { ...fill, label: next }),
                });
            }
            else if (fill.type === "offer" && fill.headline !== undefined) {
                out.push({
                    id: `slots.${slotId}[${i}].headline`,
                    label: `Slot · ${where} · Offer headline`,
                    prose: false,
                    read: () => fills[i].headline,
                    write: (content, next) => putFill(content, i, { ...fill, headline: next }),
                });
            }
        });
    }
    return out;
}
export function localizableFields(content) {
    var _a, _b, _c, _d, _e, _f;
    const out = [];
    if (content.copy)
        out.push(...copyFields(content.copy));
    out.push(...infoSectionFields((_a = content.infoSections) !== null && _a !== void 0 ? _a : [], "infoSections", "Information", (c, sections) => ({ ...c, infoSections: sections })));
    if (content.actionLists)
        out.push(...actionListFields(content.actionLists));
    if (content.welcome) {
        out.push({
            id: "welcome.title",
            label: "Welcome · Title",
            prose: false,
            read: (c) => { var _a; return (_a = c.welcome) === null || _a === void 0 ? void 0 : _a.title; },
            write: (c, next) => ({
                ...c,
                welcome: { ...c.welcome, title: next },
            }),
        });
        out.push({
            id: "welcome.body",
            label: "Welcome · Body",
            prose: true,
            read: (c) => { var _a; return (_a = c.welcome) === null || _a === void 0 ? void 0 : _a.body; },
            write: (c, next) => ({ ...c, welcome: { ...c.welcome, body: next } }),
        });
    }
    if (content.relatives) {
        out.push(...infoSectionFields((_b = content.relatives.sections) !== null && _b !== void 0 ? _b : [], "relatives.sections", "Relatives", (c, sections) => ({
            ...c,
            relatives: { ...c.relatives, sections },
        })));
    }
    if (content.homeCards) {
        for (const key of Object.keys(content.homeCards).sort()) {
            const card = content.homeCards[key];
            if (card.title !== undefined) {
                out.push({
                    id: `homeCards.${key}.title`,
                    label: `Home card · ${key} · Title`,
                    prose: false,
                    read: (c) => { var _a, _b; return (_b = (_a = c.homeCards) === null || _a === void 0 ? void 0 : _a[key]) === null || _b === void 0 ? void 0 : _b.title; },
                    write: (c, next) => {
                        var _a;
                        return ({
                            ...c,
                            homeCards: {
                                ...c.homeCards,
                                [key]: { ...(_a = c.homeCards) === null || _a === void 0 ? void 0 : _a[key], title: next },
                            },
                        });
                    },
                });
            }
            if (card.description !== undefined) {
                out.push({
                    id: `homeCards.${key}.description`,
                    label: `Home card · ${key} · Description`,
                    prose: true,
                    read: (c) => { var _a, _b; return (_b = (_a = c.homeCards) === null || _a === void 0 ? void 0 : _a[key]) === null || _b === void 0 ? void 0 : _b.description; },
                    write: (c, next) => {
                        var _a;
                        return ({
                            ...c,
                            homeCards: {
                                ...c.homeCards,
                                [key]: { ...(_a = c.homeCards) === null || _a === void 0 ? void 0 : _a[key], description: next },
                            },
                        });
                    },
                });
            }
        }
    }
    if ((_c = content.custom) === null || _c === void 0 ? void 0 : _c.items)
        out.push(...customFields(content.custom.items));
    out.push(...stationFields((_d = content.stations) !== null && _d !== void 0 ? _d : []));
    ((_f = (_e = content.menu) === null || _e === void 0 ? void 0 : _e.mealSlots) !== null && _f !== void 0 ? _f : []).forEach((slot, i) => {
        out.push({
            id: `menu.mealSlots[${i}].label`,
            label: `Menu · Serving ${i + 1}`,
            prose: false,
            read: (c) => { var _a, _b, _c; return (_c = (_b = (_a = c.menu) === null || _a === void 0 ? void 0 : _a.mealSlots) === null || _b === void 0 ? void 0 : _b[i]) === null || _c === void 0 ? void 0 : _c.label; },
            write: (c, next) => ({
                ...c,
                menu: {
                    ...c.menu,
                    mealSlots: replaceAt(c.menu.mealSlots, i, {
                        ...c.menu.mealSlots[i],
                        label: next,
                    }),
                },
            }),
        });
    });
    if (content.slots)
        out.push(...slotFields(content.slots));
    return out;
}
function stationFields(stations) {
    const out = [];
    stations.forEach((station, i) => {
        var _a;
        if ((_a = station.id) === null || _a === void 0 ? void 0 : _a.startsWith("cat-"))
            return;
        const head = crumb(station.name, station.id || `Channel ${i + 1}`);
        out.push({
            id: `stations[${i}].tag`,
            label: `Radio · ${head} · Tag`,
            prose: false,
            read: (c) => { var _a, _b; return (_b = (_a = c.stations) === null || _a === void 0 ? void 0 : _a[i]) === null || _b === void 0 ? void 0 : _b.tag; },
            write: (c, next) => ({
                ...c,
                stations: replaceAt(c.stations, i, { ...c.stations[i], tag: next }),
            }),
        });
    });
    return out;
}
export function findLocalizableField(content, id) {
    return localizableFields(content).find((f) => f.id === id);
}
